// TODO: These does not handle all cases, e.g. singularize is incorrect for "children" -> "child" or "licenses" -> "license".
// Consider using a library like `pluralize` for more comprehensive pluralization.

export const pluralize = (word = ""): string => {
  // Handle exceptions with doubling (quiz -> quizzes, fez -> fezzes)
  // Pattern: word ends with [vowel][z or s] (e.g., quiz, fez)
  if (/[aeiou][zs]$/i.test(word)) {
    return word + word.slice(-1).toLowerCase() + "es"
  }

  return (
    word.replace(/(?:s|x|z|ch|sh)$/i, "$&e").replace(/([^aeiou])y$/i, "$1ie") +
    "s"
  ).replace(/i?e?s$/i, match =>
    word.slice(-1) === word.slice(-1).toLowerCase()
      ? match.toLowerCase()
      : match.toUpperCase()
  )
}

export const pluralizeByCount = (word: string, count: number): string => {
  if (!word) {
    return ""
  }

  return count === 1 ? word : pluralize(word)
}

export const formatPlural = (
  value: number,
  label: string,
  zeroLabel = "0"
): string => {
  return value === 1
    ? `1 ${label}`
    : `${value === 0 ? zeroLabel : value} ${pluralize(label)}`
}

const endings = {
  ves: "fe",
  ies: "y",
  i: "us",
  zes: "ze",
  ses: "s",
  es: "e",
  s: ""
}

export const singularize = (word: string): string => {
  if (!word) return ""

  return word.replace(/(ves|ies|i|zes|ses|es|s)$/, r => endings[r])
}
